<template>
  <v-container class="text-center">
    <v-row class="white mx-4" style="border-bottom: 4px solid var(--vs-cinza) !important;">
      <v-col
        lg="3"
        md="3"
        sm="3"
        class="d-flex align-center justify-center"
      >Buscar pela filial mais próxima</v-col>

      <v-col lg="9" md="9" sm="9" class="d-flex align-center pb-3">
        <v-row no-gutters>
          <v-col lg="6" md="6" sm="6" class="d-flex align-center">
            <v-text-field
              v-model="cepCliente"
              label="Qual o seu CEP"
              hide-details="auto"
              v-mask="mask.cep"
              color="var(--vs-azul-secundaria)"
            ></v-text-field>
          </v-col>
          <v-col lg="2" md="2" sm="2" class="d-flex align-center">
            <vs-button color="#43A047" @click="filialProxima" border>
              <template>Pesquisar</template>
              <i class="las la-map-marked-alt pl-2" style="font-size: 16px !important"></i>
            </vs-button>
          </v-col>

          <v-col lg="4" md="4" sm="4" class="d-flex align-center">
            <vs-button color="#d32f2f" @click="limparPesquisa" border>
              <template>Limpar pesquisa</template>
              <i class="las la-times pl-2" style="font-size: 16px !important"></i>
            </vs-button>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-row class="fill-height">
        <v-col lg="12" md="12" sm="12">
          <v-card :color="filialSelecionada(filial)" v-if="filial !== null">
            <v-row
              class="fill-height flex-column border-inferior-2px d-block"
              justify="space-between"
            ></v-row>

            <v-row
              class="fill-height flex-column"
              justify="space-between"
              style="height: 100px !important"
            >
              <v-col cols="12">
                <span v-html="nomeFilial(filial)" class="font-weight-black pr-2"></span>
              </v-col>
              <v-col cols="12 py-0">
                <span v-html="capitalize(filial.filStrEndereco)" class="pr-2"></span>
                <span v-html="capitalize(filial.filStrCidade)" class="pr-2"></span> - Bairro
                <span v-html="capitalize(filial.filStrBairro)" class="pl-2 pr-2"></span> -
                <span class="pl-2 pr-2">{{filial.filChaUf}}</span>
                <span v-if="filial.filChaCep" v-html="formatarCEP(filial.filChaCep)" class="pr-2"></span>
                <span v-html="formataTelefone(filial.filChaFone)" class="pr-2"></span>
              </v-col>
              <br />
            </v-row>
          </v-card>
        </v-col>

        <template v-for="fil in allFiliais()">
          <v-col :key="fil.id" cols="12" md="6" sm="6">
            <v-card :color="filialSelecionada(fil)">
              <v-row
                class="fill-height flex-column border-inferior-2px d-block"
                justify="space-between"
              ></v-row>

              <v-row
                class="fill-height flex-column"
                justify="space-between"
                style="height: 200px !important"
              >
                <v-col cols="12 mt-4">
                  <span v-html="nomeFilial(fil)" class="font-weight-black"></span>
                </v-col>
                <v-col cols="12 py-0">
                  <span v-html="capitalize(fil.filStrEndereco)"></span>
                </v-col>
                <v-col cols="12 py-0">
                  <span v-html="capitalize(fil.filStrCidade)"></span> -
                  <span>{{fil.filChaUf}}</span> -
                  <span v-html="formatarCEP(fil.filChaCep)"></span>
                </v-col>
                <span v-html="formataTelefone(fil.filChaFone)"></span>
                <br />
              </v-row>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Alert from "../utils/alert/index";
import Constantes from "../utils/constantes";

export default {
  directives: {
    mask,
  },
  data() {
    return {
      mask: {
        fone: "(##) #####-####",
        cnpj: "##.###.###/####-##",
        cep: "#####-###",
      },
      cepCliente: null,
    };
  },
  timers: {},
  methods: {
    carregarFiliais(emp) {
      this.$store.dispatch("empresa/carregarFiliais", emp);
    },
    nomeFilial(filial) {
      let nome = filial.filStrNme.substring(filial.filStrNme.indexOf(' ') + 1);
      return nome;
    },
    capitalize(str) {
      let frase = str.toLowerCase();
      return frase.replace(/(^|\s)\S/g, (l) => l.toUpperCase());
    },
    formatarCEP(str) {
      var re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/; // Pode usar ? no lugar do *

      if (re.test(str)) {
        return str.replace(re, "$1$2-$3");
      }
      return "";
    },
    formataTelefone(str) {
      str = str.replace(/\D/g, "");
      str = str.replace(/^(\d{2})(\d)/g, "($1) $2");

      str = str.replace(/(\d)(\d{4})$/, "$1-$2");
      return str;
    },
    filialProxima() {
      this.$store.dispatch("empresa/buscarFilialProxima", {
        empIntCod: this.empresa.empIntCod,
        cep: this.cepCliente,
      });
    },
    limparPesquisa() {
      this.$store.commit("empresa/setFilial", null);
      this.cepCliente = "";
    },
    filialSelecionada(filSelecionada) {
      if (this.filial && filSelecionada.filIntCod === this.filial.filIntCod) {
        return "destaque";
      } else {
        return "nao-destaque";
      }
    },
    allFiliais() {
      if (this.filial) {
        let b = this.filiais.filter(
          (e) => e.filIntCod !== this.filial.filIntCod
        );
        return b;
      }
      return this.filiais;
    },
  },
  mounted() {
    this.carregarFiliais(this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      empresa: "anuncio/empresa",
      user: "cliente/user",
      filiais: "empresa/filiais",
      filial: "empresa/filial",
    }),
  },
};
</script>

<style scoped>
.destaque {
  border-bottom: 3px solid #d32f2f !important;
  background-color: #053b6a !important;
  color: white;
}

.nao-destaque {
  background-color: #fafafa !important;
  border-color: #fafafa !important;
}
</style>
